import { FieldDefinition, FieldBuilder, MenuCategories, MenuSubcategories, MENU_CATEGORY_KEY, MENU_SUBCATEGORY_KEY, MENU_NAME_SUFFIX } from '@zendra/shared';
import { MachineService } from '../proxy/general/controllers/machine.service';
import { ClawService } from '../proxy/general/controllers/claw.service';

FieldBuilder.setNamespace('General');

export const MACHINECLAWCHANGEHISTORIC_FIELDS: FieldDefinition[] = [
  FieldBuilder
    .date('dateFrom', 'Entity.MachineClawChangeHistoric.DateFrom')
    .lessThanField('dateTo', 'General::Entity.MachineClawChangeHistoric.DateTo')
    .required()
    .build(),
  FieldBuilder
    .date('dateTo', 'Entity.MachineClawChangeHistoric.DateTo')
    .greaterThanField('dateFrom', 'General::Entity.MachineClawChangeHistoric.DateFrom')
    .build(),
  FieldBuilder
    .foreignKey('clawId', 'Entity.Claw', ClawService)
    .required()
    .display('model.name')
    .displayFromNested('claw.model.name')
    .sortBy('claw.model.name')
    .build(),
  FieldBuilder
    .foreignKey('machineId', 'Entity.Machine', MachineService)
    .required()
    .displayFromNested('machine.name')
    .sortBy('machine.name')
    .hideInChildForms()
    .build(),
];

export const MACHINECLAWCHANGEHISTORIC_CONFIG = {
  entityName: 'MachineClawChangeHistoric',
  localizationKey: 'General::Entity.MachineClawChangeHistoric',
  fields: MACHINECLAWCHANGEHISTORIC_FIELDS,
  permission: 'GeneralMachinesAndVehicles.MachineClawChangeHistorics',
  showInMenu: true,
  menuCategory: MENU_CATEGORY_KEY + MenuCategories.General + MENU_NAME_SUFFIX,
  menuSubcategory: MENU_SUBCATEGORY_KEY + MenuSubcategories.MachinesAndVehicles + MENU_NAME_SUFFIX,
};
